var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1638501324368,
    className: "icon",
    viewBox: "0 0 1532 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 6097,
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.305654 1015.783542h1516.032096V7.547677H6.305654v1008.235865z m1522.910991 8.216458v-9.554021 9.554021zM0 1022.089196V0h1528.643404v1020.751633H0v1.242023z",
    fill: "#353636",
    "p-id": 6098
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.821609 3.821609h1522.337749v1014.445978H3.726068z",
    fill: "#CC303C",
    "p-id": 6099
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M763.65292 213.150215l75.285688 227.003545h238.27729L884.129129 581.839896l73.948124 227.003545-194.424333-140.444113-192.991229 140.444113 73.948124-227.003545-193.18231-141.686136H689.800336z",
    fill: "#FAD400",
    "p-id": 6100
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVn);
export default __webpack_public_path__ + "static/media/vn.76e4f84b.svg";
export { ForwardRef as ReactComponent };